var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("a-table", {
        key: "vtable-" + _vm.renderCount,
        staticClass: "custom-table2",
        attrs: {
          columns: _vm.cols(),
          dataSource: _vm.getFilteredRows(),
          loading: _vm.isBusy,
          locale: {
            emptyText: _vm.$t("message.noNewUser"),
          },
          pagination: false,
          rowKey: "_id",
          bordered: true,
        },
        on: { change: _vm.tableChange },
        scopedSlots: _vm._u(
          [
            {
              key: "roleSlot",
              fn: function (data, item) {
                return _c("div", { key: "roleSlot" + _vm.$i18n.locale }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(null != item.role ? item.role.name : "-") +
                      "\n        "
                  ),
                ])
              },
            },
            {
              key: "departmentSlot",
              fn: function (data, item) {
                return _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "tippy",
                        rawName: "v-tippy",
                        value: {
                          followCursor: true,
                          placement: "top-right",
                        },
                        expression:
                          "{\n                followCursor: true,\n                placement: 'top-right',\n            }",
                      },
                    ],
                    key: "departmentSlot" + _vm.$i18n.locale,
                    staticClass: "departmentSlot",
                    attrs: { content: _vm.getUserDepartmentNames(item) },
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.getUserDepartmentNames(item)) +
                        "\n        "
                    ),
                  ]
                )
              },
            },
            {
              key: "enableStateSlot",
              fn: function (data, item) {
                return _c(
                  "div",
                  { key: "enableStateSlot" + _vm.$i18n.locale },
                  [
                    item.enable
                      ? _c("a-icon", {
                          staticClass: "text-success",
                          attrs: { type: "check" },
                        })
                      : _c("a-icon", {
                          staticClass: "text-danger",
                          attrs: { type: "close" },
                        }),
                  ],
                  1
                )
              },
            },
            {
              key: "lastLoginPlatformSlot",
              fn: function (data, item) {
                return _c(
                  "div",
                  { key: "lastLoginPlatformSlot" + _vm.$i18n.locale },
                  [
                    item.lastLoginPlatform === "mobile"
                      ? _c(
                          "div",
                          { staticClass: "mr-2 text-primary" },
                          [
                            _c("a-icon", { attrs: { type: "mobile" } }),
                            _vm._v("\n                Mobile\n            "),
                          ],
                          1
                        )
                      : _c(
                          "div",
                          [
                            _c("a-icon", {
                              staticClass: "mr-2 text-primary",
                              attrs: { type: "chrome" },
                            }),
                            _vm._v("\n                WEB\n            "),
                          ],
                          1
                        ),
                  ]
                )
              },
            },
            {
              key: "statusSlot",
              fn: function (data, item) {
                return _c("div", { key: "statusSlot" + _vm.$i18n.locale }, [
                  item.isOnline
                    ? _c(
                        "span",
                        {
                          staticClass: "st-item onlineMode",
                          class: _vm.statuses.find(function (s) {
                            return s.status === item.status
                          }).class,
                        },
                        [
                          _c("font-awesome-icon", {
                            staticClass: "mr-2",
                            attrs: {
                              icon: _vm.statuses.find(function (s) {
                                return s.status === item.status
                              }).icon,
                            },
                          }),
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.$t(
                                  _vm.statuses.find(function (s) {
                                    return s.status === item.status
                                  }).langKey
                                )
                              ) +
                              "\n            "
                          ),
                        ],
                        1
                      )
                    : _c(
                        "span",
                        {
                          staticClass: "st-item offlineMode",
                          class: _vm.statuses.find(function (s) {
                            return s.status === item.status
                          }).class,
                        },
                        [
                          _c("font-awesome-icon", {
                            staticClass: "mr-2",
                            attrs: {
                              icon: _vm.statuses.find(function (s) {
                                return s.status === item.status
                              }).icon,
                            },
                          }),
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.$t(
                                  _vm.statuses.find(function (s) {
                                    return s.status === item.status
                                  }).langKey
                                )
                              ) +
                              "\n            "
                          ),
                        ],
                        1
                      ),
                ])
              },
            },
            {
              key: "actionsSlot",
              fn: function (data, item) {
                return _c("div", { key: "actionsSlot" + _vm.$i18n.locale }, [
                  _c("div", {
                    staticClass: "d-flex w-100 justify-content-start",
                  }),
                ])
              },
            },
          ],
          null,
          true
        ),
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mt-3 d-flex justify-content-end" },
        [
          _c("Pagination", {
            attrs: {
              "page-change": _vm.pageChange,
              "page-sizes": _vm.pageSizes,
              total: _vm.users.total,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }